"use strict";

var _regeneratorRuntime = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAOnPress = defaultAOnPress;
exports.default = void 0;
var _reactNative = require("react-native");
function defaultAOnPress(_x, _x2) {
  return _defaultAOnPress.apply(this, arguments);
}
function _defaultAOnPress() {
  _defaultAOnPress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_e, href) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _reactNative.Linking.openURL(href);
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            console.warn("Could not open URL \"".concat(href, "\"."), _context.t0);
          case 8:
            return _context.abrupt("return", null);
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _defaultAOnPress.apply(this, arguments);
}
var defaultRendererProps = {
  img: {
    initialDimensions: {
      height: 50,
      width: 50
    },
    enableExperimentalPercentWidth: false
  },
  a: {
    onPress: defaultAOnPress
  },
  ol: {},
  ul: {}
};
var _default = defaultRendererProps;
exports.default = _default;